import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

const APP_SVG_ICONS: ReadonlyArray<readonly [name: string, path: string]> = [
    ["aphpssj-photo-empty", "/assets/icons/photo.svg"],
    ["aphpssj-dashboard-page-title-icon", "/assets/icons/analytics-bars.svg"],
    ["aphpssj-volunteers-page-title-icon", "/assets/icons/single-neutral-id-card-1.svg"],
    ["aphpssj-members-page-title-icon", "/assets/icons/multiple-neutral-2.svg"],
    ["aphpssj-nav-home-analytics", "/assets/icons/analytics-bars.svg"],
    ["aphpssj-nav-volunteers-id-card", "/assets/icons/single-neutral-id-card-1.svg"],
    ["aphpssj-nav-members-group", "/assets/icons/multiple-neutral-2.svg"],
    ["aphpssj-more-filters", "/assets/icons/filter-3.svg"]
];

export function registerAppSvgIconsFactory(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
): () => void {
    return () => {
        for (const [name, path] of APP_SVG_ICONS) {
            iconRegistry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(path));
        }
    };
}
